import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import LeftNav from '@tekion/tap-components/molecules/LeftNav';
import TokenManager from '@tekion/tap-components/utils/TokenManager';
import Loader from '@tekion/tap-components/atoms/Loader';
import { APP_RELEASE_VERSION } from '../../../config/Meta';
import Loadable from '../../hocs/withLoadable.hoc';

const Header = Loadable(React.lazy(() => import(/* webpackChunkName: "Header" */ '@tekion/tap-components/molecules/Header')));
const Footer = Loadable(React.lazy(() => import(/* webpackChunkName: "Footer" */ '@tekion/tap-components/molecules/Footer')));

const { BASE_URL } = process.env;

const Layout = (props) => {
  const [loadComponent, setloadComponent] = useState(false);
  const { children, location } = props;
  useEffect(() => {
    if (TokenManager.isAuthenticated()) {
      setloadComponent(true);
    } else {
      let redirectUrl = '/login';
      if (location && location.pathname) {
        redirectUrl = `/login?url=${location.pathname}`;
      }
      TokenManager.clearAllCookies();
    }
  }, []);
  const _renderLayout = () => (
    <React.Fragment>
      <Header apiBaseUrl={BASE_URL} />
      <section>
        <LeftNav modules={['/app']} apiBaseUrl={BASE_URL} />
      </section>
      <React.Fragment>
        {children}
      </React.Fragment>
      <section>
        <Footer apiBaseUrl={BASE_URL} version={APP_RELEASE_VERSION} disableFSRecording />
      </section>
    </React.Fragment>
  );
  const _renderLoad = () => (
    <Loader id="Layout" />
  );
  return (
    <React.Fragment>
      {!loadComponent ? _renderLoad() : _renderLayout()}
    </React.Fragment>
  );
};
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};
export default Layout;
